module.exports = __webpack_public_path__ + "static/img/tec-bio.2c30d24.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/technology/tec-bio.jpg
// module id = ndDe
// module chunks = 1